export default {
  女装: "د ښځو جامې",
  男装: "سړي",
  手机和小工具: "د ګرځنده تلیفون او کوچني وسیلو",
  居家生活: "کورنی ژوند",
  电脑及周边设备: "کمپیوټر او د څنډي تجهیزات",
  美容及个人护理: "ښکلا او شخصي پاملرنه",
  家用电器: "تجهیزات",
  健康与保健: "روغتیا او روغتیا پاملرنه",
  食品和饮料: "خواړه او څښاک",
  玩具_儿童和婴儿: "لوبي، ماشومان او ماشومان",
  童装时尚: "د ماشومانو جامې فیشن",
  视频游戏: "ويډيو ګېم",
  运动与户外: "تمرین او بیروني",
  爱好与书籍: "شوق او کتابونه",
  相机和无人机: "کیمره او بې ځایه شوي",
  宠物食品及用品: "د څارویو خواړه او اکمالات",
  女士包袋: "د میرمنو کڅوړه",
  男士包袋: "د سړو کڅوړه",
  珠宝及配饰: "ګا welry ې او لوازمات",
  手表: "وګوره",
  女鞋: "د ښځو بوټونه",
  男装鞋: "د سړو بوټان",
  汽车: "موټر",
  我附近的ShopeePay: "زما نزدې شفر",
  餐饮_旅行和服务: "خواړه، سفر او خدمت",
  旅行及行李: "سفر او سامان",
  各种各样的: "بیلابیل",
  我是来买什么的: "زه دلته د پیرود لپاره یم",
  对不起_找不到_相关的商品: "بښنه غواړم، تاسو نشئ موندلی [{0}] اړوند محصولات",
  类别: "کټګورۍ",
  产品: "محصول",
  店铺: "پلورنځی",
  首页: "مخینه پاڼه",
  限时秒杀: "محدود وخت",
  博客: "بلاګ",
  所有品牌: "ټولې نښې",
  所有类别: "ټولې کټګورۍ",
  我的购物车: "زما د پیرودلو کارټ",
  发货信息: "د تحویلي معلومات",
  交货信息: "د تحویلي معلومات",
  付款: "تادیه",
  确认: "تصدیق وکړئ",
  您的购物车是空的: "ستاسو د پیرودلو کارټ خالي دی",
  价格: "بيه",
  税: "مالیه",
  数量: "مقدار",
  总计: "ټول",
  移除: "لرې کول",
  返回商店: "پلورنځي ته راستون شئ",
  继续发货: "تحویل ته دوام ورکړئ",
  筛选: "فلټر",
  价格范围: "بيه",
  排序方式: "برابرول",
  最新: "تر دې نیټې",
  最旧: "زوړ",
  价格从低到高: "له ټیټ څخه تر لوړ پورې قیمت",
  价格从高到低: "د لوړ څخه ټیټ څخه قیمت",
  选择交货类型: "د تحویلي ډول غوره کړئ",
  送货上门: "تحویلي",
  继续付款: "تادیه ته دوام ورکړئ",
  任何其他信息: "کوم بل معلومات",
  或者: "یا",
  您的钱包余额: "ستاسو د والټ بیلانس",
  余额不足: "ناکافي توازن",
  支付: "پیسې ورکول",
  我同意: "زه همغږی یم",
  条款和条件: "شرایط او شرایط",
  退货政策: "راستنیدنه تګلاره",
  隐私政策: "محرمیت",
  概括: "شاتړ",
  项目: "پروژه",
  全部的: "ټول",
  小计: "سکیچ",
  总运费: "ټول بار",
  有优惠码吗_在这里输入: "ایا د تخفیف کوډ شته؟ دلته ننوځئ",
  申请: "غوښتنه وکړئ",
  编辑: "سمون",
  删除: "حذف کول",
  添加新地址: "نوې پته اضافه کړئ",
  继续交货信息: "د تحویلي معلوماتو ته دوام ورکړئ",
  选择一个地址: "یو پته غوره کړئ",
  购买历史: "تاریخ وپیرۍ",
  下载: "ډاونلوډ",
  已发送退款请求: "د بیرته ستنیدو غوښتنه د بیرته ستنیدو غوښتنه لیږي",
  对比: "برعکس",
  对话: "خبرې اترې",
  我的钱包: "زما بټوه",
  工单: "د کار امر",
  管理个人资料: "شخصي معلومات اداره کړئ",
  登出: "وتون",
  重置对比列表: "د پرتله کولو پرتله کولو لیست",
  您的对比列表为空: "ستاسو پرتله کولو لیست خالي دی",
  在您的购物车中: "ستاسو د پیرودلو کارټ کې",
  在您的愿望清单中: "ستاسو د غوښتنې لیست کې",
  在您的预定列表中: "ستاسو په ټاکل شوي لیست کې",
  下载您的产品: "خپل محصول ډاونلوډ کړئ",
  选项: "غوراوي",
  什么都没找到: "ما هیڅ ونه موندل",
  特色产品: "ځانګړی محصول",
  最畅销: "غوره - ښکلا",
  前_名: "مخکینی {0} نوم",
  查看更多: "نور وګوره",
  查看所有类别: "ټول کټګورۍ وګورئ",
  十大品牌: "غوره لس نښې",
  查看所有品牌: "ټولې نښې وګورئ",
  登录: "ننوتل",
  手机号码: "د تلیفون شمیره",
  密码: "رمز",
  密码长度为6到16个字符: "د شفر اوږدوالی له 6 څخه تر 16 حروف دی",
  验证码: "د تایید کوډ",
  登录中: "ننوتل",
  游客登录: "د ګرځندوی ننوتل",
  注册您的商店: "خپل پلورنځي ثبت کړئ",
  现在申请: "اوس غوښتنه وکړه",
  成为商家: "سوداګري شه",
  现在注册: "اوس یی ثبت کړه",
  登录成功: "بریالۍ ننوتل",
  通知: "خبرداری ورکړه",
  未找到通知: "هیڅ خبرتیا نشته",
  评论: "نظر",
  估计运输时间: "اټکل شوی د ترانسپورت وخت",
  天: "اسمان",
  所售: "پلور",
  给商家留言: "سوداګر ته یو پیغام پریږدئ",
  规格: "توضيح",
  库存: "په سټاک کې",
  总价: "عمومي قیمت",
  添加到购物车: "په کارټ کې اضافه کړئ",
  立即购买: "اوس یې وپیرئ",
  缺货: "له زېرمې بهر",
  添加到愿望清单: "د غوښتلون لیست کې اضافه کړئ",
  加入对比列表: "د پرتله کولو لیست اضافه کړئ",
  退款: "بیرته ستنیدنه",
  查看条款: "مهربانی وګورئ",
  分享: "شریکول",
  描述: "تشریح یی کړه",
  相关产品: "اړوند محصولات",
  没有人问过商家: "هیچا د سوداګر څخه غوښتنه نه ده کړې",
  该产品暂无评论: "پدې محصول کې هیڅ نظر نشته",
  客户评论: "د پیرودونکي نظر",
  访问商店: "پلورنځي څخه لیدنه وکړئ",
  畅销产品: "غوره - ښکلا محصولات",
  日期: "نېټه",
  订单编号: "د امر شمیره",
  总额: "ټولیز مبلغ",
  状态: "دولت",
  愿望清单: "د هیلې لړۍ",
  还没有添加任何东西: "تراوسه هیڅ شی نه دی کړی",
  注册: "ثبتول",
  邀请码: "د بلنې کوډ",
  请输入邀请码: "مهرباني وکړئ د بلنې کوډ دننه کړئ",
  用户名: "کارن نوم",
  请输入用户名: "مهرباني وکړئ د کارونکي نوم دننه کړئ",
  用户名长度为6_14个字符: "د کارونکي نوم اوږدوالی 6-14 حروف دی",
  昵称: "نیک نوم",
  请输入手机号码: "مهرباني وکړئ د ګرځنده تلیفون شمیره دننه کړئ",
  手机号码格式错误: "د ګرځنده تلیفون شمیره فارمیټ تېروتنه",
  密码长度为6_16个字符: "د شفر اوږدوالی 6-16 حروف دی",
  确认密码: "د رمز تایید کړئ",
  请输入确认密码: "مهرباني وکړئ د تایید پاسورډ دننه کړئ",
  提款密码: "د وتلو پاسورډ",
  请输入提款密码: "مهرباني وکړئ د وتلو پاسورډ دننه کړئ",
  提款密码长度为4_16个字符: "د وتلو پاسورډ اوږدوالی د 4-16 حروف دی",
  请输入验证码: "مهرباني وکړئ د تایید کوډ دننه کړئ",
  在_s后发送: "د {0} S وروسته ولیږئ",
  发送验证码: "د تایید کوډ واستوئ",
  注册即表示您同意我们的条款和条件:
    "نوم لیکنه پدې معنی ده چې تاسو زموږ د شرایطو او شرایطو سره موافق یاست.",
  创建账号: "ګڼون جوړ کړئ",
  验证码发送成功: "د تایید کوډ په بریالیتوب سره لیږي",
  确认密码不一致: "تایید کړئ چې پټنوم متناقض دی",
  提款密码必须为数字: "د وتلو پاسورډ باید شمیرې وي",
  注册成功: "په بریالیتوب سره ثبت کړئ",
  购物车: "د شاپنرېد کارټ",
  账户: "ګڼون",
  我的账户: "زما حساب",
  已经有一个账户: "دمخه یو حساب لري",
  新地址: "نوی پته",
  编辑地址: "د مدیر پته",
  保存: "خوندي کړئ",
  是否默认: "ایا ډیفالټ ته",
  具体地址: "ځانګړی پته",
  请输入具体地址: "مهرباني وکړئ ځانګړي پته دننه کړئ",
  地区: "سیمه",
  请输入地区: "مهرباني وکړئ سیمه دننه کړئ",
  城市: "ښار",
  请输入城市: "مهرباني وکړئ ښار دننه کړئ",
  省份: "ولایت",
  请输入省份: "مهرباني وکړئ ولایت ته ننوتل",
  邮政编码: "پوستي کوډ",
  请输入邮政编码: "مهرباني وکړئ پوستي کوډ دننه کړئ",
  电话号码: "د تلیفون شمیره",
  请输入电话号码: "مهرباني وکړئ د تلیفون شمیره دننه کړئ",
  收货人: "جوړه",
  请输入收货人: "مهرباني وکړئ ټریګین دننه کړئ",
  保存成功: "بریالي اوسئ",
  最畅销的商家: "غوره - ښکلا سوداګر",
  查看所有的商家: "ټول سوداګریز وګورئ",
  支持政策: "ملاتړ تګلاره",
  您的电子邮件地址: "ستاسو د بریښنالیک آدرس",
  订阅: "ګډون",
  联系方式: "د اړیکې معلومات",
  地址: "پته",
  美国伊利诺伊州霍夫曼庄园: "هالفم مانور، ایلینوس، USA",
  快速链接: "ګړندی لینک",
  商家政策: "د سوداګر تګلاره",
  submit: "وسپارئ",
  提款银行卡: "د اډاب کارت",
  我的面板: "زما پینل",
  提示: "اشاره",
  确定登出吗: "ایا ته باوري یې چې ننوتل؟",
  确定: "ډاډه یم",
  取消: "لغوه کول",
  项目添加到您的购物车: "پروژه ستاسو د پیرودلو کارټ کې اضافه کیږي",
  经常一起购买: "څو ځله واخلئ",
  返回购物: "د شاپینګ بیرته ستنیدل",
  进行结算: "چیک چیک ته لاړشئ",
  帮助热线: "د هاټ لاین سره مرسته وکړئ",
  查看所有通知: "ټول خبرتیاوې چیک کړئ",
  请输入密码: "مهرباني وکړئ رمز دننه کړئ",
  前往充值: "ریچارج ته لاړ شه",
  购物车物品: "د شاپنرېد کارټ",
  查看购物车: "د شاپینګ کارټ چیک کړئ",
  钱包余额: "د والټ توازن",
  充值钱包: "د چارج کڅوړه",
  钱包充值_线下_: "د والټ ریچارج (آفلاین)",
  申请提款: "د وتلو لپاره غوښتنه وکړئ",
  钱包收支明细: "د والټ عاید او مصرف توضیحات",
  批准: "منظور",
  提现历史记录: "د ګمارنې تاریخي ریکارډ",
  类型: "ډول",
  信息: "معلومات",
  付款方式: "د تادیې طریقه",
  请选择付款方式: "مهرباني وکړئ د تادیې طریقه غوره کړئ",
  Bill_Type_RECHARGE_BACK: "شالید ریچارج",
  Bill_Type_RECHARGE_ONLINE: "آنلاین ریچارج",
  Bill_Type_RECHARGE_REGISTER: "ثبتول",
  Bill_Type_RECHARGE_JACKPOT: "ریچارج",
  Bill_Type_RECHARGE_PRESENT: "د چارج کولو انعام",
  Bill_Type_RECHARGE_FROM_COMMISSION: "د کمیسیون لیږد",
  Bill_Type_RECHARGE_TG_COMMISSION: "د چارج کمیسیون",
  Bill_Type_REGISTER_TG_COMMISSION: "ثبت او ترویج کمیسیون",
  Bill_Type_WITHDRAW: "وتل",
  Bill_Type_WITHDRAW_REJECT: "وتل",
  Bill_Type_DEDUCT_HANDLE: "د لارښود تخفیف",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "ریچارج",
  Bill_Type_MINING_PROFIT: "د کانونو عاید",
  Bill_Type_MINING_PROFIT_COMMISSION: "د کان کیندنې عاید ترویج کمیسیون",
  Bill_Type_VIP_UPGRADE: "د",
  Bill_Type_FINANCE_BUY: "د شتمني مدیریت محصول پیرود",
  Bill_Type_FINANCE_CAPITAL_RETURN: "مالي توازن بیرته ستنیدل",
  Bill_Type_FINANCE_FEE: "د مالي اداره کولو لګښت",
  Bill_Type_FINANCE_PROFIT: "مالي عاید",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "د شتمنیو مدیریت محصولاتو لپاره د پیرود کمیسیونونه",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "د شتمني مدیریت محصول عاید کمیسیون",
  Bill_Type_WHEEL_DRAW: "لوی ټنډبلونکی رافیل",
  Bill_Type_BUY: "توکي وپیرئ",
  Bill_Type_PAY_SHOP: "د تحویلي فیس ورکول",
  Bill_Type_BUY_COMMISSION: "د توکو کمیسیون وپیرئ",
  Bill_Type_DEPOSIT: "جمع تادیه کړئ",
  Bill_Type_STORE_BUY: "توکي وپیرئ",
  Bill_Type_STORE_BUY_REFUND: "بیرته ستنیدنه واخلئ",
  Bill_Type: "د پور بدلون ډول",
  Before_Money: "تېر مقدار",
  Deal_Money: "د حساب بدلون اندازه",
  After_Money: "ورپسې اندازه",
  Bill_Time: "د حساب بدلون وخت",
  No_More_Data: "نور معلومات نشته",
  Apply_Money: "د غوښتنلیک مقدار",
  Apply_Time: "د غوښتنلیک وخت",
  Withdraw_Info: "د سمبالولو لګښت: {د فیس} حساب ته: {پیسې}",
  提款订单状态_CHECKING: "د بیاکتنې لپاره",
  提款订单状态_TRANSFERRING: "انتقال",
  提款订单状态_PASS: "تصدیق وکړئ",
  提款订单状态_REJECT: "رد شو",
  暂无可用充值方式: "هیڅ ګټور د چارج کولو میتود نشته",
  钱包收款码: "د والټ ټولولو کوډ",
  钱包地址: "والټ پته",
  金额限制: "اندازه محدودیت",
  复制: "کاپي",
  付款凭证: "د تادیې واؤچر",
  收款银行: "د ترلاسه کیدونکي بانک",
  收款人: "کاشیریا",
  收款账号: "رسید حساب",
  付款银行: "پیسې ورکړه",
  付款人: "تادیه کونکی",
  付款账号: "د تادیې حساب",
  请输入付款银行: "مهرباني وکړئ د تادیې بانک دننه کړئ",
  请输入付款人: "مهرباني وکړئ تادیه کونکي دننه کړئ",
  请输入付款账号: "مهرباني وکړئ د تادیې حساب دننه کړئ",
  请上传付款凭证: "مهرباني وکړئ د تادیې واؤچر اپلوډ کړئ",
  充值金额: "د چارج کولو اندازه",
  请输入充值金额: "مهرباني وکړئ د ریچارج اندازه دننه کړئ",
  submitting: "وړاندې شوی ...",
  Confirm: "وسپارئ",
  Commit_Success: "بریالۍ سپارنه",
  balanceType_BALANCE: "بیلانس",
  balanceType_COMMISSION: "کمیسیون",
  Balance: "د حساب توازن",
  Wash_Money: "کوډینګ",
  请选择银行账户: "مهرباني وکړئ د بانک حساب وټاکئ",
  卡号类型: "د کارت شمیره",
  提现金额: "د وتلو مقدار",
  提款金额: "د وتلو مقدار",
  不能为空: "خالي نشي کیدی",
  金额不正确: "ناسم مقدار",
  please_input_withdraw_password: "مهرباني وکړئ د وتلو پاسورډ دننه کړئ",
  withdraw_password_format_error: "د وتلو پاسورډ باید د 4-16-BA بټ حروف وي",
  Fee: "د ورکولو لګښت",
  实际到账: "په حقیقت کې",
  交易币种: "د سوداګرۍ اسعارو",
  原始密码: "لومړنی پاسورډ",
  confirm_password_error: "په دوو توکو کې رمز غلط دی",
  save_success: "بریالي اوسئ",
  please_input: "مهرباني وکړئ دننه یې کړئ",
  old_password: "زوړ پاسورډ",
  new_password: "نوی رمز",
  please_input_confirm_password: "مهرباني وکړئ بیا رمز تایید کړئ",
  没有找到符合条件的商品: "وړ محصولات نشي موندلی",
  Search: "لټون",
  全部: "ټول",
  EnumGoodsOrderState_USER_PAY: "چې وویشل شي",
  EnumGoodsOrderState_SHOP_PAY: "ویش",
  EnumGoodsOrderState_SUCCESS: "بشپړول",
  EnumGoodsOrderState_CANCEL: "لغوه کول",
  EnumGoodsOrderState_REFUND_SUCCESS: "بیرته ستنیدنه",
  订单号: "د امر شمیره",
  用户名称: "د کارونکي نوم",
  收益: "عاید",
  支付时间: "وخت د ورکړه",
  配送时间: "د تحویلي وخت",
  完成时间: "بشپړ وخت",
  发货: "بېړۍ",
  全选: "بشپړ ټاکنه",
  物品已添加到愿望清单: "توکي د غوښتنې لیست کې اضافه شوي",
  物品已添加到比较列表: "توکي د پرتله کولو لیست کې اضافه شوي",
  购买成功提示: "مبارک شه، په بریالیتوب سره وپیرئ",
  订单列表: "د امر لیست",
  商品名: "د محصول نوم",
  图片: "انځور",
  没有品牌: "نښه نشته",
  基本信息: "لومړني معلومات",
  Account_Name: "نوم",
  Bank_Account: "د بانک ګڼوڼ",
  Bank_Phone: "د ګرځنده تلیفون شمیره",
  IFSC: "IFSC حساب",
  UPI: "اپري حساب",
  PIX: "د PIX حساب شمیره",
  CPF: "د CPF حساب",
  GCASH: "ګریش حساب",
  POWWI: "د Pomi حساب",
  身份证号: "د پېژندپاڼې شمېره",
  Edit: "بیا کتنه",
  Delete: "حذف کول",
  Add: "زیاتوالی",
  Forget_Withdraw_Password: "د وتلو پاسورډ سره هیر کړئ",
  Bank_Card_Info: "د بانک کارت معلومات",
  收款人地址: "د کیشیر پته",
  SWIFT: "سویټ",
  Bank_Branch: "د فرعي --بچ نوم",
  分行代码: "د څانګې کوډ",
  银行地址: "د بانک پته",
  Email: "بریښنالیک",
  银行卡长度必须超过:
    "د بانک کارت اوږدوالی باید له pilding ساعتونو څخه ډیر شي}",
  银行卡格式不正确: "د بانک کارت ب format ه غلط ده",
  Do_you_confirm_delete: "ایا تاسو حذف کوئ؟",
  Please_Login_First: "مهرباني وکړئ لومړی کې ننوتل",
  Bank_Name: "د بانک نوم",
  Please_add_bank_first:
    "تاسو د بانک کارت بند نه دی، مهرباني وکړئ لومړی یې اضافه کړئ",
  withdrawType: "وتل",
  withdraw_money_limit:
    "د وتلو اندازه باید له 0 څخه لوړه وي او له {بیلانس} سره مساوي یا مساوي وي",
  withdraw_times_limit:
    "تاسو نن ورځ راجستر شوی {نن ورځې وخت ترلاسه کړی. وروسته {محدودیت} وخت، تاسو به د لاسي وتلو کاري فیس چارج کړئ. ایا دا هوډ لري چې پیسې وباسي؟",
  Copy_Success: "انګروزه",
  商店首页: "کور پا page ه ذخیره کړئ",
  所有产品: "ټول محصولات",
  新到货产品: "د نوي - برلیز محصول",
  所有商家: "ټول سوداګر",
  请上传: "مهرباني وکړئ اپلوډ کړئ",
  请输入: "مهرباني وکړئ دننه یې کړئ",
  忘记密码: "رمز مو هیر کړه",
  记得我: "ما په یاد ولره",
  共_件: "ټول {0} یوه ټوټه",
  取消订单: "امر لغوه کړئ",
  申请退款: "د بیرته ستنیدو لپاره غوښتنه وکړئ",
  未知商家: "نامعلوم سوداګر",
  到账: "ګڼون",
  提款订单状态: "د وتلو امر حالت",
  前_名类别: "د لومړي {0} کټګورۍ",
  取消订单原因_不想要了: "نور مه کوې",
  取消订单原因_商品错选_多选: "د محصول غلطي / ډیری انتخاب",
  取消订单原因_商品无货: "د",
  取消订单原因_地址信息填写错误: "د پته معلوماتو غلطي ډک کړئ",
  取消订单原因_商品降价: "د اجناسو نرخ کمول",
  取消订单原因_价格高于其他平台: "قیمت د نورو پلیټونو څخه لوړ دی",
  取消订单原因_没用_少用_错用优惠: "هیڅ / د لږ / خطا تخفیف وکاروئ",
  退款原因_拍错_多拍_不喜欢: "غلط / شوټ نور مه کوئ",
  退款原因_商品成分描述不符: "د محصول اجزا مسله سمون نه خوري",
  退款原因_与商家协商一致退款: "د سوداګر بیرته ستنیدو سره مشوره",
  退款原因_生产日期_保质期与商品描述不符:
    "د تولید نیټه / د شیلف ژوند د محصول توضیح سره سمون نه خوري",
  退款原因_图片_产地_批号_规格等描述不符:
    "د اصلي / بیچ نمبر / مشخصاتو عکس / د توضیحاتو ځای، او نور.",
  退款原因_质量问题: "د کیفیت مسله",
  退款原因_商品变质_发霉_有异物: "د محصول خرابیدل / باکس / بهرني بدن",
  退款原因_少件_含缺少配件_: "لږ توکي (د لوازمو په شمول)",
  退款原因_收到商品时有破损_污渍_变形:
    "کله چې د محصول ترلاسه کول، نو شتون لري / د حوصلې / تخفیف دی",
  退款原因_假冒品牌: "جعلي",
  退款原因_发票问题: "د انوائس ستونزه",
  退款原因_商家发错货: "سوداګریز غلط مالونه واستوي",
  退款原因_预约不到_商家不给退换: "ناسته نشي کولی / سوداګر به بیرته راشي",
  退款失败: "د بیرته ستنیدو ناکامي",
  退款处理中: "د بیرته ستنولو پروسس",
  默认: "ډیفالټ",
  产品查询: "د تولید پوښتنه",
  商店LOGO: "د پلورنځي لوگو",
  推广码: "د ترویج کوډ",
  查看所有: "ټول وګوره",
  确认收货成功: "تایید کړئ چې رسید بریالی دی",
  物流公司: "لوژستیک شرکت",
  物流单号: "د لوژستیک آرډر شمیره",
  发货时间: "د تحویلي وخت",
  请先选择商品规格: "مهرباني وکړئ لومړی د محصول ځانګړتیا غوره کړئ",
  个人信息: "شخصي معلومات",
  您的用户名: "ستاسو کارن نوم",
  你的名字: "ستا نوم",
  登录名: "کارن نوم",
  你的邮件: "ستا میل",
  你的密码: "ستاسو رمز",
  重复输入密码: "پټنوم تکرار کړه",
  店铺名称: "د پلورنځي نوم",
  证书类型: "ډول",
  身份证: "شناخت کارت",
  护照: "پاسپورټ",
  驾驶执照: "د موټر چلونکي جواز",
  社会保障卡: "ټولنیز امنیت کارت",
  证书正面: "مثبت سند",
  证书反面: "ثبوت",
  确认收货: "د توکو رسول تایید کړئ",
  请选择取消订单的原因必选:
    "مهرباني وکړئ د امر لغوه کولو لپاره دلیل وټاکئ (اړین):",
  请选择申请退款的原因必选:
    "مهرباني وکړئ د بیرته ستنیدو لپاره د غوښتنلیک لپاره دلیل وټاکئ (اړین):",
  留言: "پیغام",
  请输入留言: "مهرباني وکړئ یو پیغام دننه کړئ",
  没有帐户: "هیڅ حساب نشته",
  钱包充值: "د ولټ ریچارج",
  输入您的文字: "خپل متن دننه کړئ",
  商家登录: "د مرچه ننوتل",
  有关此产品的任何查询: "په دې محصول کې هره پوښتنه",
  产品名称: "د محصول نوم",
  你的问题: "ستاسو ستونزه",
  白银店铺: "د سپینو زرو شاپ",
  铂金店铺: "پلاتین شاپ",
  钻石店铺: "دیلاس شاپ",
  照片: "انځور",
  已退货: "بېرته راستون شو",
  邮寄状态: "د کرنې حالت",
  订单摘要: "د اشارې غوښتنه",
  收件地址: "د عاید پته",
  订购日期: "د امر نیټه",
  订单状态: "د امر حالت",
  总订单金额: "د ټول امر مقدار",
  邮寄方式: "د کرنې طریقه",
  附加信息: "اضافي معلومات",
  订单详细信息: "تفصيلي معلومات",
  交货类型: "د تحویلي ډول",
  进行评论: "نظر",
  已评论: "تبصره وکړه",
  订单金额: "د ترتیب مقدار",
  优惠券: "کوپن",
  统一运费: "متحد بار",
  送货地址: "د بار وړلو پته",
  评分: "نمره",
  你的意见: "ستاسو نظر",
  匿名: "بې نومه",
  现金: "نغدي",
  详情: "تفصیل",
  收货地址: "رسید پته",
  暂时没有对话: "د وخت لپاره هیڅ ډول خبرو هیڅ نه دی",
  你: "ته",
  输入您的回复: "خپل ځواب دننه کړئ",
  删除成功: "حذف کول",
  品牌: "برانډ",
  已缴纳的保证金: "پیسې ورکړل شوې",
  黄金店铺: "زرین پلورنځي",
  没有更多数据: "نور معلومات نشته",
  站内信: "د",
  系统通知: "د سیسټم خبرتیا",
  邮箱: "میل",
  手机号: "د تلیفون شمیره",
  你的手机号: "ستاسو د ګرځنده تلیفون شمیره",
  营业执照: "د سوداګرۍ جواز",
  你的邮箱: "ستاسو میل باکس",
  搜索结果: "پایلې",
  系统公告: "د سیسټم اعلان",
  客服: "د پیرودونکو خدمت",
  消息已撤回: "خبرونه بیرته واخیستل شول",
  物流详情: "د لوژستیک توضیحات",
  充值: "پورته پورته",
  提现: "وتل",
  信用分: "کریډیټ",
  余额: "بیلانس",
  佣金: "کمیسیون",
  继续购物: "خرڅلاو ته ادامه ورکړه",
  订单结算: "جوړجاړی",
  加入对比: "پرتله کول اضافه کړئ",
  佣金余额: "د کمیسیون توازن",
  刷新: "تازه کول",
  刷新成功: "تازه کول",
  官网: "رسمي ویب پاه",
  税号: "د مالیې شمیره",
  订单: "امر",
  合计: "ټول",
  系统安全: "د سیسټم امنیت",
  Recharge_Money_Limit: "د ریچارج اندازه باید د {Mine} تر مینځ وي او {میکس}",
  限时优惠: "محدود وخت",
  高价回收: "لوړ پوړي شوی ریسایکل",
  姓名: "نوم",
  商品订单号: "د اجناسو امر شمیره",
  商品在线回收: "د اجناسو آنلاین ریسایکلینګ",
  提交: "وسپارئ",
  回收记录: "د بیا رغونې ریکارډ",
  回收状态: "د رغیدو حالت",
  回收价格: "د ریسایکل کولو قیمت",
  纳税码: "د مالیې کوډ",
  买家登录: "ننوتل",
  买家注册: "ثبتول",
  language: "چینایی",
  助力提示:
    "د سوداګریزو سوداګرو سره مرسته کول کولی شي د پلیټ فارم د دوی پلورنځیو ته زیان ورسوي، او د ورځو مجموعي شمیر لوړ وي، لوړ د توضیحاتو لوړ.",
  已累计助力: "په مجموعي ډول مرسته شوې",
  今日已助力: "نن ورځ مرسته کړې",
  立即助力: "سمدلاسه مرسته وکړه",
  商家助力: "د سوداګر مرسته",
  证件号码: "د پېژندپاڼې شمېره",
  证书号码: "د سند شمیره",
  男鞋: "د سړو بوټان",
  游戏玩具: "د لوبې لوبو",
  使用条款: "د کارولو شرایط",
  商家: "سوداګار",
  已助力: "مرسته کړې",
  被助力: "مرسته شوې",
  用户: "کارن",
  助力记录: "د مرستې ریکارډ",
  消息类型: "د پیغام ډول",
  消息内容: "د پیغام مینځپانګه",
  链接: "لینک",
  文本: "متن",
  清空: "روښانه",
  评论成功: "څرګندونې بریالۍ",
  扫描二维码: "د QR کوډ سکین کړئ",
  转入: "انتقال",
  收款: "ټولګه",
  任务下单中心: "د دندې امر مرکز",
  记录: "ریکارډ",
  任务倒计时: "د دندې شمیرنه",
  倒计时后自动放弃: "د شمیرنې وروسته په اتوماتيک ډول پریږدئ",
  业务码: "د سوداګرۍ کوډ",
  选择商品分类: "د محصول کټګورۍ غوره کړئ",
  可多选: "ډیری انتخابونه ممکن دي",
  加载分类中: "د کټګوریو بار کول",
  暂无分类: "تراوسه طبقه بندي نه ده",
  产品类别: "د محصول کټګوري",
  账户余额: "د حساب توازن",
  立即结算: "سمدلاسه حل کول",
  任务已自动放弃: "دنده په اوتومات ډول پریښودل شوې",
  商品分类: "د محصول طبقه بندي",
  订单详情: "د امر توضیحات",
  预计收益: "اټکل شوي عواید",
  预计佣金收益: "د کمیسیون اټکل شوي عاید",
  收益率: "حاصل",
  扣款账户: "د حساب حساب",
  确认结算: "تصفیه تایید کړئ",
  未选择: "نه ټاکل شوی",
  请选择商品分类: "مهرباني وکړئ د محصول کټګورۍ غوره کړئ",
  下单成功: "امر په بریالیتوب سره کیښودل شو",
  下单失败: "امر ناکام شو",
  请重试: "مهرباني وکړئ بیا هڅه وکړئ",
  订单记录: "د امر ریکارډ",
  没有更多了: "نور نه",
  业务号: "د سوداګرۍ شمیره",
  商品类型: "د محصول ډول",
  佣金收益: "د کمیسیون عاید",
  待结算: "د تصفیې پاتې دي",
  已结算: "آباد شوی",
  已取消: "لغوه شو",
  加载失败: "بار کول ناکام شول",
  倒计时: "شمېرنه",
  随机商品: "تصادفي توکي",
  为: "لپاره",
  商户助力可提升商品曝光度: "د سوداګر مرسته کولی شي د محصول افشا کول زیات کړي",
  累计助力越高推荐权重越高:
    "څومره چې راټولې شوې مرستې لوړې وي، د سپارښتنې وزن هم لوړ وي.",
  实时助力动态: "د ریښتیني وخت مرستې متحرکات",
  助力奖励: "انعامونه لوړ کړئ",
  随机奖励金额已生成: "د تصادفي انعام مقدار رامینځته شوی",
  开心收下: "د منلو لپاره خوشحاله",
  助力已结束: "مرسته پای ته ورسیده",
  助力成功: "د بریالیتوب سره مرسته وکړئ",
  成功: "بریالیتوب",
  进行中: "په پرمختګ کې",
  等待: "انتظار",
  助力失败: "مرسته ناکامه شوه",
  任務: "دنده",
  下单失败_请稍后重试: "آرڈر ناکام شو ، براه کرم وروسته تکرار کوشش کړئ",
  任务: "دنده"
};
